import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import "../styles/Login.css";
import logo from "../assets/logo.png";


const Login = () => {
  const { login, getSavedCredentials } = useAuth();
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    rememberMe: false
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isTransitioning, setIsTransitioning] = useState(false);

  useEffect(() => {
    const savedCreds = getSavedCredentials();
    if (savedCreds) {
      setFormData({
        username: savedCreds.username || "",
        password: savedCreds.password || "",
        rememberMe: true
      });
    }
  }, [getSavedCredentials]);

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
    if (errors.form) {
      setErrors((prev) => ({ ...prev, form: "" }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.username.trim()) {
      newErrors.username = "Vui lòng nhập tên đăng nhập";
    }
    if (!formData.password) {
      newErrors.password = "Vui lòng nhập mật khẩu";
    }
    return newErrors;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (isLoading) return;

    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsLoading(true);
    try {
      const loginPath = process.env.REACT_APP_LOGIN_PATH || "/mobile-api/Login";

      const ua = navigator.userAgent;
      let browserName = "Browser";
      if (ua.includes("Edg/")) browserName = "Edge";
      else if (ua.includes("Chrome/")) browserName = "Chrome";
      else if (ua.includes("Firefox/")) browserName = "Firefox";
      else if (ua.includes("Safari/")) browserName = "Safari";
      const platform = /Mobile|Android|iPhone|iPad/.test(ua) ? "Mobile" : "Desktop";
      const deviceInfo = `WebApp - ${browserName} ${platform}`;

      const response = await fetch(loginPath, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          maSo: formData.username,
          matKhau: formData.password,
          deviceInfo
        })
      });

      if (response.status === 401 || response.status === 404) {
        throw new Error("Sai tài khoản hoặc mật khẩu");
      }

      if (!response.ok) {
        throw new Error("Đăng nhập thất bại. Vui lòng thử lại.");
      }

      const data = await response.json();

 
      if (!data.success) {
        throw new Error(data.message || "Sai tài khoản hoặc mật khẩu");
      }


      const userInfo = data.userInfo || {};
      const hoVaTen = userInfo.hoVaTen && userInfo.hoVaTen.trim() !== ""
        ? userInfo.hoVaTen
        : "Chưa xác định";

      const normalizedUser = {
        username: formData.username,
        maSo: userInfo.maSo || formData.username,
        name: hoVaTen,
        hoVaTen: hoVaTen,
        role: "user",
        token: data.token,
        expiryDate: data.expiryDate,
        quyenHanhDong: userInfo.quyenHanhDong || null
      };

      login(formData.username, formData.password, formData.rememberMe, normalizedUser);
      setIsLoading(false);
      setIsTransitioning(true);

      setTimeout(() => {
        window.location.href = "/trangchu";
      }, 1800);
    } catch (error) {
      setIsLoading(false);
      setErrors((prev) => ({
        ...prev,
        form:
          error?.message === "Failed to fetch"
            ? "Không thể kết nối máy chủ. Vui lòng thử lại."
            : error?.message || "Đăng nhập thất bại. Vui lòng thử lại."
      }));
    }
  };

  return (
    <div className={`login ${isTransitioning ? "login--transitioning" : ""}`}>
      <div className={`login__transition ${isTransitioning ? "login__transition--active" : ""}`}>
        <div className="login__transition-circle"></div>
        <div className={`login__transition-logo ${isTransitioning ? "login__transition-logo--fade" : ""}`}>
          <img src={logo} alt="Logo Bệnh viện" className="login__transition-image" />
        </div>
      </div>

      <div className="login__background">
        <div className="login__bg-gradient"></div>
        <div className="login__bg-pattern"></div>
        <div className="login__bg-circles">
          <div className="login__circle login__circle--1"></div>
          <div className="login__circle login__circle--2"></div>
          <div className="login__circle login__circle--3"></div>
          <div className="login__circle login__circle--4"></div>
        </div>
        <div className="login__bg-wave"></div>
      </div>

      <div className={`login__container ${isTransitioning ? "login__container--hide" : ""}`}>
        <div className="login__header">
          <div className="login__logo-wrapper">
            <img src={logo} alt="Logo Bệnh viện" className="login__logo" />
          </div>
          <h1 className="login__title">{process.env.REACT_APP_LOGIN_TITLE || 'HÙNG VƯƠNG GIA LAI'}</h1>
          <p className="login__subtitle">Hệ Thống Quản Lý Tuyển Dụng</p>
        </div>

        <div className="login__card">
          <div className="login__card-header">
            <h2 className="login__card-title">Đăng nhập</h2>
            <p className="login__card-subtitle">Chào mừng bạn trở lại</p>
          </div>

          <form className="login__form" onSubmit={handleSubmit}>
            <div className="login__field">
              <label htmlFor="username">Tên đăng nhập</label>
              <div className={`login__input ${errors.username ? "login__input--error" : ""}`}>
                <span className="login__input-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </span>
                <input
                  id="username"
                  name="username"
                  type="text"
                  placeholder="Nhập tên đăng nhập"
                  value={formData.username}
                  onChange={handleChange}
                  autoComplete="username"
                  className="login__input-field"
                />
              </div>
              {errors.username && <span className="login__field-error">{errors.username}</span>}
            </div>

            <div className="login__field">
              <label htmlFor="password">Mật khẩu</label>
              <div className={`login__input ${errors.password ? "login__input--error" : ""}`}>
                <span className="login__input-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
                  </svg>
                </span>
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder="Nhập mật khẩu"
                  value={formData.password}
                  onChange={handleChange}
                  autoComplete="current-password"
                  className="login__input-field"
                />
              </div>
              {errors.password && <span className="login__field-error">{errors.password}</span>}
            </div>

            {errors.form && (
              <div className="login__form-error" role="alert">
                {errors.form}
              </div>
            )}

            <div className="login__options">
              <label className="login__remember">
                <input
                  type="checkbox"
                  name="rememberMe"
                  checked={formData.rememberMe}
                  onChange={handleChange}
                />
                <span className="login__remember-checkmark"></span>
                <span className="login__remember-text">Ghi nhớ đăng nhập</span>
              </label>
            </div>

            <button type="submit" className="login__button" disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className="login__button-spinner"></span>
                  <span>Đang xử lý...</span>
                </>
              ) : (
                <>
                  <span>Đăng nhập</span>
                  <span className="login__button-icon" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M5 12h14M12 5l7 7-7 7" />
                    </svg>
                  </span>
                </>
              )}
            </button>
          </form>

          <div className="login__divider">
            <span>hoặc</span>
          </div>

          <div className="login__help">
            <p>
              Bạn cần hỗ trợ? Liên hệ <a href="https://zalo.me/0376299300">0376 299 300</a>
            </p>
          </div>
        </div>

        <footer className="login__footer">
          <p className="login__copyright">
            © Copyright 2026 {process.env.REACT_APP_FOOTER_NAME || 'Bệnh Viện Đa Khoa Hùng Vương'}
          </p>
          <p className="login__powered">
            Powered by Ban Chuyển Đổi Số - leanhquan™
          </p>
        </footer>
      </div>

  
    </div>
  );
};

export default Login;
